<template>
  <dialog-zoomer v-model="viz" v-on:close="handleClose">
    <div class="quote-panel">
      <div class="close-box" v-on:click="viz = false"></div>
      <div class="dark-panel">
        <div v-show="!submitted">
          <div class="quote-flex">
            <div class="quote-header"><h3>{{ $nippets.quote.heading }}</h3></div>
            <div class="logo">
              <img v-if="!animation" src="@/assets/img/illustrationx.svg" width="178" />
              <img v-if="animation" src="@/assets/img/animationx.svg" width="178" />
            </div>
          </div>
          <div class="quote-subhead" v-if="artist">
            {{ $nippets.replace('quote.intro','artist', firstName )}}
          </div>
          <div class="input-panel">
            <div class="item">
              <label for="name">{{ $nippets.quote.yourName }}</label>
              <input type="text" name="name" :placeholder="$nippets.quote.yourName" v-model="details.name" />
            </div>
            <div class="item">
              <label for="position">{{ $nippets.quote.position }}</label>
              <input type="text" name="position" :placeholder="$nippets.quote.position" v-model="details.position" />
            </div>
            <div class="item">
              <label for="company">{{ $nippets.quote.company }}</label>
              <input type="text" name="company" :placeholder="$nippets.quote.company" v-model="details.company" />
            </div>
            <div class="item">
              <label for="email">{{ $nippets.quote.email }}</label>
              <input type="text" name="email" :placeholder="$nippets.quote.email" v-model="details.email" />
            </div>
            <div class="item">
              <label for="tel">{{ $nippets.quote.tel }}</label>
              <input type="text" name="tel" :placeholder="$nippets.quote.tel" v-model="details.tel" />
            </div>
            <div class="item">
              <label for="artist">{{ $nippets.quote.artist }}</label>
              <input type="text" name="tel" :placeholder="$nippets.quote.artist" v-model="details.artist" />
            </div>
            <div class="item">
              <label for="brief">{{ $nippets.quote.brief }}</label>
              <textarea name="brief" :placeholder="$nippets.quote.briefPlaceholder" cols="4" wrap v-model="details.brief" />
            </div>
            <div class="item">
              <label for="file">{{ $nippets.quote.addFile}}</label>
              <div style="flex-grow:2;width:100%;display:flex;flex-wrap:true;align-items:flex-start;">
                <small-button v-on:click="clickFileInput">+</small-button>
                <div style="display:flex;flex-wrap:wrap">
                  <div v-for="(file, index) in files" class="filebox" :key="'file' + index" v-on:click.stop="removeFile(file)">{{ file.filename }}</div>
                </div>
                <input type="file" name="file" ref="fileInput" multiple v-on:change="addToFiles" v-show="false" />
              </div>
            </div>
          </div>
          <div class="button-panel">
            <small-button large :loading="loading" v-on:click="handleUpload">{{ $nippets.quote.send }}</small-button>
          </div>
        </div>

        <transition name="fade">
          <div v-show="submitted">
            <div class="quote-flex">
              <div class="quote-header"><h3>{{ $nippets.quote.thankYou }}</h3></div>
              <div class="logo"><img src="@/assets/img/illustrationx.svg" width="178" /></div>
            </div>
            <div class="quote-subhead" v-if="artist">
              {{ $nippets.quote.thanks }}
            </div>
          </div>
        </transition>
      </div>
      <div class="light-panel">
        <div class="item">
          <div class="strong">{{ $nippets.quote.writtenBook }}</div>
          <div class="para" v-html="$nippets.quote.readOurGuide" v-on:click="$k.sendGaEvent('CommissioningGuide', 'Click', $store.state.lang)"></div>
        </div>
        <div class="item">
          <div class="strong">{{ $nippets.quote.newToCom }}</div>
          <div class="para">{{ $nippets.quote.checkOut }}<ix-router-link to="/commissioning">{{ $nippets.quote.quickGuide}}</ix-router-link></div>
        </div>
        <div class="item">
          <div class="strong">{{ $nippets.quote.wantHelp }}</div>
          <div class="para">
            <router-link :to="$ixr.contactLink">{{ $nippets.quote.contactAgent }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </dialog-zoomer>
</template>

<script>
import DialogZoomer from '@/components/dialogs/DialogZoomer.vue'

export default {
  components: {
    DialogZoomer
  },
  data () {
    return {
      viz: false,
      artist: null,
      loading: false,
      details: {},
      submitted: false,
      files: []
    }
  },
  computed: {
    animation() {
      return (this.$route.path.indexOf('/animat') >= 0)
    },
    firstName: function () {
      if(this.artist) {
        let spl = this.artist.formatted_name.split(' ')
        if(spl.length > 0) return spl[0]
        return this.artist.formatted_name
      }
      return ''
    }
  },
  created: function () {
    this.initArtist()
  },
  methods: {
    removeFile(file) {
      this.files = this.files.filter(el => el.filename !== file.filename)
    },
    clickFileInput () {
      this.$refs.fileInput.click()
    },
    initArtist: function () {
      this.files = []
      if(this.artist) {
        this.details.artist = this.artist.formatted_name
      }
    },
    verifyForm: function () {
      if(!this.$k.validEmail(this.details.email)) {
        this.showMessageBox(this.$nippets.quote.validEmail)
        return false
      }
      return true
    },
    showMessageBox: async function (message) {
      this.$store.commit('setMessage', { title: this.$nippets.quote.heading, message: message, show: true})
    },
    managefile(afile) {
      return new Promise( (resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.onload = () => {
            if(reader.result.length > 5000000) {
              reject(this.$nippets.quote.fiveMb)
            }
            const item = { filename: afile.name, b64: btoa(reader.result)}
            this.files.push(item)
            resolve()
          }
          reader.readAsBinaryString(afile)
        }
        catch(err) {
          reject(err)
        }
      })
    },
    async addToFiles() {
      
      let files = this.$refs.fileInput.files
      if(!files) {
        return
      }
      for(let file of files) {
        if(this.files.length > 4) {
          this.showMessageBox('Max 5 files')
          break
        }
        try {
          await this.managefile(file)
        }
        catch(err) {
          this.showMessageBox(err)
          this.loading = false
          return
        }
      }
    },
    handleUpload: async function () {
      if(!this.verifyForm()) {
        return
      }
      
      this.loading = true
      this.doUpload ()
      
    },
    doUpload: async function () {
      try {
        let info = {}
        // this line would make it only send to me
        //info.debug = true
        if(this.files.length > 1) { // multiple files are stored on s3 and linked in message body
          info.files = []
          for(let file of this.files){
            info.files.push({
              filename: file.filename,
              b64: file.b64
            })
          }
        } // if only one file, it gets attached
        else if(this.files.length === 1) {
          info.filename = this.files[0].filename
          info.file = this.files[0].b64
        }
        info.details = this.details
        info.details.lang = this.$store.state.lang
        info.details.utms = JSON.stringify(this.$store.state.utms)
        info.details.referer = this.$store.state.referer
        info.details.visitor_id = this.$store.getters.visitorId
        info.details.session_id = this.$store.getters.sessionId
        // reinstate
        
        let res = await this.$apix.post('events/quote', info)
        let action = 'Illustration Quote Request'
        if(this.animation) {
          action = 'Animation Quote Request'
        }
        // reinstate
        this.$k.sendGaEvent('ArtistQuote', action, this.details.artist)
        console.log(res.data)
        this.loading = false
        this.submitted = true
      }
      catch(err) {
        alert('failure')
        console.log(err)
      }
      this.loading = false
    },
    handleClose: function () {
      this.$store.commit('setShowQuote', false)
      this.submitted = false
    }
  },
  watch: {
    '$store.state.quote.show': function () {
      if(this.$store.state.quote.show) {
        this.artist = this.$store.state.quote.artist
        this.viz = true
        this.files = []
      }
    },
    '$route.path': function () {
      this.viz = false
    },
    artist: function () {
      this.initArtist()
    }
  }
}
</script>

<style scoped>
.quote-panel{
  width: 70vw;
  max-width:800px;
  border-radius: 30px;
  background-color:#efefea;
  padding:0;
  display:flex;
  box-sizing:border-box;
  align-items:stretch;
  overflow-x: hidden;
  overflow-y:auto;
  cursor:default;
  max-height:96vh;
}



.quote-subhead{
  margin:20px 0;
  padding-right:30%;
}


.button-panel:after {
  content: "";
  display: block;
  height: 25px;
  width: 100%;
}


.dark-panel{
  background-color:#e8e8e3;
  width:70%;
  padding:32px 23px 20px 42px;
}

.light-panel{
  background-color:#efefea;
  width:30%;
  padding:82px 42px 42px 23px;
  font-size:14px;
  line-height:18px;
}

.close-box{
  opacity:0.3;
  top:20px;
  right:20px;
}

.input-panel{
  margin:25px 0;
}

.close-box:hover{
  opacity: 1;
}

h3{
  display:block;
  margin:0;
  color:#8b6f4b;
  font-weight:500;
  font-size:23px;
}

.quote-flex{
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.right-panel{
  width:25%;
}

.strong{
  font-weight:500;
}

.para{
  font-weight:400;
  color:#6d6d64;
}

.item{
  margin-bottom:16px;
}

.filebox{
  padding:4px 24px 4px 8px;
  font-size:12px;
  line-height:16px;
  background-color:#8b6f4b;
  border-radius:4px;
  color:#fff;
  margin:0 4px 4px 0;
  cursor:pointer;
  background-position: center right 3px;
  background-size:16px;
  transition:all 0.1s ease-in-out;
  background-image:url('../../assets/img/close-white.svg');
}

.filebox:hover{
  padding-right:24px;
  background-color:#ce0e2d;
}


@media screen and (max-width:640px){
  .quote-panel{
    width: 99vw;
    padding:0;
    display:block;
    box-sizing:border-box;
    align-items:stretch;
    overflow-x: hidden;
    overflow-y:auto;
    cursor:default;
    max-height:96vh;
  }

  .quote-subhead{
    padding-right:0;
    width:auto;
  }

  .dark-panel{
    width:100%;
    padding:16px 36px 16px 16px;
    box-sizing:border-box;
  }

  .light-panel{
    width:100%;
    padding-top:25px;
  }

  .close-box{
    top:10px;
    right:10px;
    width:20px;
    height:20px;
  }

  .input-panel .item{
    display:block;
  }

  .input-panel .item label{
    width:auto;
  }

  .quote-flex{
    display:block;
  }
}
</style>
